import { FC } from 'react';
import { IconChip } from '../common/IconChip';
import { LINKS } from '@silo/types';
import { AlertChip, ExternalLink, SnowflakeIcon, Tooltip, TooltipContent, TooltipOrigin } from '@silo/ui';

interface PausedProps {
  includeTooltip?: boolean;
  iconOnly?: boolean;
}

export const PausedChip: FC<PausedProps> = ({ includeTooltip = false, iconOnly = false }) => {
  if (!includeTooltip) {
    return <PausedIndicator iconOnly={iconOnly} />;
  }

  return (
    <Tooltip placement="bottom-start">
      <TooltipOrigin className="flex">
        <PausedIndicator iconOnly={iconOnly} />
      </TooltipOrigin>
      <TooltipContent>
        <div className="flex flex-col gap-2.5">
          <p className="font-normal">This silo is temporarily frozen. Actions within this silo are disabled. </p>
          <ExternalLink href={LINKS.SILOPEDIA.FROZEN_SILO} size="small" />
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

const PausedIndicator: FC<{ iconOnly: boolean }> = ({ iconOnly }) => {
  if (iconOnly)
    return (
      <IconChip>
        <SnowflakeIcon className="w-4 h-4 text-white" />
      </IconChip>
    );
  return <AlertChip icon={<SnowflakeIcon className="w-4 h-4" />} label="Frozen" />;
};
